import React, { useState, useEffect } from "react";
import littleGuy from "../../TDD-Images/little-guy-alone_2.png";
import { capitalizeFirstLetter, generateGUID, getPackName, hasMultipleQuestionPacks, hasPremSub, parseQuestionQuery } from '../utils/utils';
import { useNavigate } from 'react-router-dom';
import { companyOptions, JobDescription, SessionQuestion, track, type, User } from '@/utils/types';
import buddy from '../../TDD-Images/buddysteppingstone.png'
import { useAppContext } from "../appContext";
import { createSvgIcon } from '@mui/material/utils';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import { IconButton, TextField, Autocomplete, Chip, Stack, InputAdornment } from '@mui/material';
import UploadFile from './UploadFile';
import { DeviceHubOutlined, ElevatorOutlined, ErrorOutline, TaskAltOutlined } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { updateJobDescriptions, uploadUserResume } from '@/api';
import LoadingOverlay from './loadingOverlay';
import { BITESIZEDQuestions } from "@/utils/BiteSizedQuestions";
import { saveInfo } from "./signup";
import Nav from "./nav";

const DefaultRole = "Software Engineering";

const sampleJD = `Job Description
e.g. 
Microsoft is seeking a talented and motivated Software Engineer to join our dynamic team. As a Software Engineer, you will be responsible for designing, developing, and maintaining high-quality software solutions that drive our innovative products and services. You will work in a collaborative environment with cross-functional teams to create cutting-edge technology that impacts millions of users worldwide.

Responsibilities:

Design and Development: Design, develop, and implement software solutions that meet the needs of our customers and align with our strategic goals.
Code Quality: Write clean, maintainable, and efficient code following best practices and coding standards.
Collaboration: Collaborate with product managers, designers, and other engineers to gather requirements, define project scope, and deliver high-quality software on time.
Testing and Debugging: Perform unit testing, integration testing, and debugging to ensure the reliability and performance of the software.
Continuous Improvement: Participate in code reviews, provide constructive feedback, and continuously improve software development processes.
Documentation: Create and maintain technical documentation to support software development and deployment processes.
Innovation: Stay up-to-date with the latest industry trends and technologies, and apply them to improve existing products and develop new solutions.
Qualifications:

Education: Bachelor's or Master's degree in Computer Science, Engineering, or a related field.
Experience: 2+ years of experience in software development, preferably in a high-tech environment.
Technical Skills:
Proficiency in one or more programming languages such as C#, Java, Python, or JavaScript.
Experience with software development frameworks and tools such as .NET, Angular, React, or similar.
Knowledge of cloud platforms such as Azure, AWS, or Google Cloud.
Strong understanding of data structures, algorithms, and software design principles.
Problem-Solving: Excellent problem-solving skills and the ability to think critically and creatively.
Communication: Strong written and verbal communication skills, with the ability to clearly articulate technical concepts to non-technical stakeholders.
Team Player: Ability to work effectively both independently and as part of a team.
Preferred Qualifications:

Experience with DevOps practices and tools such as Docker, Kubernetes, Jenkins, or Git.
Familiarity with Agile development methodologies.
Experience with AI and machine learning technologies.
Contributions to open-source projects or participation in hackathons and coding competitions.`;


const DropdownWithInput: React.FC<{options: string[], handleChange: (x:string)=>void}> = ({options, handleChange}) => {
  const [value, setValue] = useState<string | null>(null);
  return (
    <Autocomplete
      freeSolo
      options={options}
      value={value}
      onChange={(event, newValue) => {
        if (newValue === null) {
          setValue(null);
          handleChange("");
        } else {
          setValue(newValue);
          handleChange(newValue);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select existing or type a new name"
          variant="outlined"
          size="small"
          fullWidth
        />
      )}
    />
  );
};


const SearchBarWithIcon = ({options, editable, handleChange}: {options:string[], editable:boolean, handleChange: (x:string)=>void}) => {
  const [value, setValue] = useState<string | null>(null);

  return (
    <Autocomplete
      fullWidth
      options={options}
      sx={{textAlign:'left'}}
      freeSolo={editable}
      value={value}
      onChange={(event, newValue) => {
        if (newValue === null) {
          setValue(null);
          handleChange("");
        } else {
          setValue(newValue);
          handleChange(newValue);
        }
      }}
      renderInput={(params) => (
          <TextField
              {...params}
              label="Search"
              variant="outlined"
              size="small"
              fullWidth     
        />
      )}
    />
  );
};

let roles = [
  "Product Management", 
  "Software Engineering",
  "Data Scientist",
  "Business Analyst",
  "Cybersecurity Engineering",
  "Technical Program Management",
  "Web Development"
];


const LandingPage_NSBE = () => {
  
  const {auth0, state, reducers, startFunc, stopAudio, resumeSession,navigateThenRun, isAuth } =
    useAppContext();

  const getLastSavedSessionForRole = () => {
      if(state.role !== "" && state.profileUser?.savedSessions && Object.keys(state.profileUser?.savedSessions).length > 0)
      {
        const sessions = state.profileUser!.savedSessions;
        const keys = Object.keys(sessions).reverse(); //start from latest
        for(const key of keys){
          if(sessions[key].session[0].role === state.role){
            return sessions[key].session;
          }
        }
      }
      return [];
  }

  const navigate = useNavigate();
  const [parsedQuery, setParsedQuery] = useState<{ [key: string]: string }>({});
  const [lastSavedSessionForRole, setlastSavedSessionForRole] = useState<SessionQuestion[]>(getLastSavedSessionForRole());
  const [readOnly, setReadOnly] = useState(true);
  const [roleValue, setRoleValue] = useState<string>("");
  const [jobDescriptionQValue, setjobDescriptionQValue] = useState<JobDescription>({ title: "", description: "" });
  const [domainValue, setDomainValue] = useState<string>("");
  const [resume, setResume] = useState<{ text: string; file: string }>({
    text: "",
    file: "",
  });
  const jobDescriptions = state.profileUser ? (state.profileUser.JobDescriptions !== undefined ? state.profileUser.JobDescriptions : {}) : null;
  const JDOptions = jobDescriptions ? Object.keys(jobDescriptions) : [];

  const {
    setloading,
    setcurrentQuestion,
    setcurrScreen,
    setsession,
    setrole,
    setdomain,
    setcustomQ,
    setjobDescriptionQ,
    settype,
    settrack,
    setintQuestion,
    setqType,
    setretryPast,
    setrunSetQs,
    setprofileUser,
    setshowPaymentModal
  } = reducers;

  useEffect(() => {
    if (state.role) {
      NavigateToBiteSized();
    }
  }, [state.role]);

  useEffect(() => {
    if ((state.track === track.CUSTOM || state.track === track.BITESIZED ) && state.questions[state.track]) {
      let sessionId = generateGUID();
      setsession([{
        question: state.questions[state.track][0], 
        feedback: "", 
        actionsteps: "", 
        prompt: [],
        fullprompt: [], 
        samplesolution: "", 
        code: "",
        useWhiteboard: state.useWhiteboard, 
        codingLang: state.codingLang, 
        time: 0, 
        isHelpful: null,
        isHelpfulMessage:  null,
        role: state.role,
        feedbackDuration: 0,
        sessionId: sessionId,
        biteSizeOptions: state.track === track.BITESIZED ? BITESIZEDQuestions[state.type].options : undefined,
    }]);
      startFunc(0);
    }
    if(state.track === track.RESUMED)
    {
      startFunc(0, false);
    }
  }, [state.questions]);

  const NavigateForCustom = () => {
    settype(type.CUSTOM);
    settrack(track.CUSTOM);
    setcurrentQuestion(0); 
    setqType("choose question");
    setrunSetQs(true); 
  }

const NavigateToQBank = (type:string, track: string, domain:string = "")=>{
  settype(type);
  settrack(track);
  setdomain(domain);
  setqType('choose question');
  setcurrentQuestion(-1);
  setintQuestion(4);
  setrunSetQs(true);
  navigate('/track');
}

const NavigateToBiteSized = ()=>{
  settype(type.BEHAVIORAL);
  settrack(track.BITESIZED);
  setqType('choose question');
  setcurrentQuestion(0);
  setqType("choose question");
  setrunSetQs(true); 
}

  return (
    <>
           
    <div className='full-nav'>
      <div className="dashboardScreen">
        <div className='dashboardContent'>
          <div className="flex-col w-[100%] items-center">
            <div className="flex-col items-start">              
              <div className="mt-[15dvh] min-w-[75vw]  flex items-start">
                <img src={buddy} className="buddy mt-5" alt="buddy" />
                <div className="flex-col gap-3 shadow-sm mb-5 p-3 bg-white w-[100%]">
                  {
                    <div className='text-left w-[100%]'>
                      <div className=""><p className='mr-5 text-grayBlue text-2xl mb-1' >Hi, I'm Buddy</p>
                        <p className='text-customBlack mb-2'>Search or type a custom role to jumpstart your journey.</p>
                      </div>
                      <div className='flex mt-3 justify-between w-[100%]'>
                        <SearchBarWithIcon options={roles}
                        editable={true}
                        handleChange={(role)=>setRoleValue(role.toLowerCase())}/>
                        {roleValue !== "" && <div data-custom-user-click="SubmitCustomRole" className='px-3 py-2 ml-3 text-white cursor-pointer hover:bg-grayBlue-hover font-[300] bg-grayBlue rounded-md shadow-sm' onClick={()=>setrole(roleValue.toLowerCase())}><p>Go</p></div>}
                      </div>
                    </div>}
                </div>
              </div>
            
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default LandingPage_NSBE;